export const LEGACY_TIME_ZONE_IDS: Record<string, readonly string[]> = {
  '-1::CVST': ['Atlantic/Cape_Verde'],
  '-2::U': ['America/Noronha'],
  '-2.5::NDT': ['America/St_Johns'],
  '-3::ADT': ['America/Glace_Bay'],
  '-3::AST': ['America/Argentina/Buenos_Aires'],
  '-3::BST': ['America/Bahia'],
  '-3::ESAST': ['America/Sao_Paulo'],
  '-3::GDT': ['America/Godthab'],
  '-3::MST': ['America/Montevideo'],
  '-3::SEST': ['America/Araguaina'],
  '-4::CBST': ['America/Campo_Grande'],
  '-4::EDT': ['America/Detroit'],
  '-4::PSST': ['America/Santiago'],
  '-4::PYT': ['America/Asuncion'],
  '-4::SWST': ['America/Anguilla'],
  '-4.5::VST': ['America/Caracas'],
  '-5::CDT': ['America/Chicago', 'America/Bahia_Banderas'],
  '-5::EST': ['America/Detroit'],
  '-5::SPST': ['America/Bogota'],
  '-5::UEDT': ['America/Indiana/Marengo'],
  '-6::CAST': ['America/Belize'],
  '-6::CCST': ['America/Regina'],
  '-6::MDT': ['America/Chihuahua'],
  '-7::PDT': ['America/Santa_Isabel', 'America/Los_Angeles'],
  '-7::UMST': ['America/Creston'],
  '-8::AKDT': ['America/Anchorage'],
  '-8::PST': ['America/Los_Angeles'],
  '-12::DST': ['Etc/GMT+12'],
  '0::ADT': ['America/Scoresbysund'],
  '0::GMT': ['Europe/London'],
  '0::GST': ['Africa/Abidjan'],
  '0::UTC': ['UTC'],
  '1::BST': ['Europe/London'],
  '1::GDT': ['Atlantic/Canary'],
  '1::MDT': ['Africa/Casablanca'],
  '1::NST': ['Africa/Windhoek'],
  '1::WCAST': ['Africa/Algiers'],
  '2::CEDT': ['Europe/Belgrade', 'Europe/Sarajevo'],
  '2::EST': ['Africa/Cairo'],
  '2::LST': ['Africa/Tripoli'],
  '2::RDT': ['Africa/Ceuta'],
  '2::SAST': ['Africa/Blantyre'],
  '2::WEDT': ['Arctic/Longyearbyen'],
  '3::AST': ['Asia/Baghdad', 'Asia/Aden'],
  '3::EAST': ['Africa/Addis_Ababa'],
  '3::EEDT': ['Asia/Nicosia'],
  '3::FDT': ['Europe/Helsinki'],
  '3::GDT': ['Asia/Nicosia'],
  '3::JDT': ['Asia/Jerusalem'],
  '3::JST': ['Asia/Amman'],
  '3::KST': ['Europe/Kaliningrad'],
  '3::MEDT': ['Asia/Beirut'],
  '3::MSK': ['Europe/Kirov'],
  '3::SDT': ['Asia/Damascus'],
  '3::TDT': ['Europe/Istanbul'],
  '4::AST': ['Asia/Dubai'],
  '4::CST': ['Asia/Yerevan'],
  '4::GET': ['Asia/Tbilisi'],
  '4::MST': ['Indian/Mahe'],
  '4::SAMT': ['Europe/Astrakhan'],
  '4.5::AST': ['Asia/Kabul'],
  '4.5::IDT': ['Asia/Tehran'],
  '5::ADT': ['Asia/Baku'],
  '5::PKT': ['Asia/Karachi'],
  '5::WAST': ['Antarctica/Mawson'],
  '5::YEKT': ['Asia/Yekaterinburg'],
  '5.5::IST': ['Asia/Kolkata'],
  '5.5::SLST': ['Asia/Colombo'],
  '5.75::NST': ['Asia/Kathmandu'],
  '6::BST': ['Asia/Dhaka'],
  '6::CAST': ['Antarctica/Vostok'],
  '6.5::MST': ['Asia/Rangoon'],
  '7::NCAST': ['Asia/Novokuznetsk'],
  '7::SAST': ['Antarctica/Davis'],
  '8::CST': ['Asia/Hong_Kong'],
  '8::MPST': ['Asia/Brunei'],
  '8::NAEST': ['Asia/Irkutsk'],
  '8::NAST': ['Asia/Krasnoyarsk'],
  '8::TST': ['Asia/Taipei'],
  '8::UST': ['Asia/Choibalsan'],
  '8::WAST': ['Antarctica/Casey'],
  '9::JST': ['Asia/Dili'],
  '9::KST': ['Asia/Pyongyang'],
  '9::YST': ['Asia/Chita'],
  '9.5::ACST': ['Australia/Darwin'],
  '9.5::CAST': ['Australia/Adelaide'],
  '10::AEST': ['Australia/Melbourne'],
  '10::EAST': ['Australia/Brisbane'],
  '10::TST': ['Australia/Currie'],
  '10::WPST': ['Antarctica/DumontDUrville'],
  '11::CPST': ['Antarctica/Macquarie'],
  '11::VST': ['Asia/Sakhalin'],
  '12::MST': ['Asia/Anadyr'],
  '12::NZST': ['Antarctica/McMurdo'],
  '12::U': ['Etc/GMT-12'],
  '13::KDT': ['Asia/Kamchatka'],
  '13::SST': ['Pacific/Apia'],
  '13::TST': ['Etc/GMT-13'],
}
